import { Box, Tooltip, Typography } from "@mui/material";
import { ExtractionConfidence } from "../../files/files.module";
import {
	errorColor,
	successColor,
	successPrimary,
	warningColor,
	white,
} from "../../../core/theme";

const CONFIDENCE_COLORS: Record<ExtractionConfidence, string> = {
	[ExtractionConfidence.HIGH]: successColor,
	[ExtractionConfidence.GOOD]: successPrimary,
	[ExtractionConfidence.FAIR]: warningColor,
	[ExtractionConfidence.LOW]: errorColor,
};

export interface ExtractionConfidenceBadgeProps {
	value?: ExtractionConfidence | string | null;
	description?: string | null;
}

export const ExtractionConfidenceBadge = ({
	value,
	description,
}: ExtractionConfidenceBadgeProps) => {
	if (!value) return null;
	const backgroundColor =
		CONFIDENCE_COLORS[value as ExtractionConfidence] ?? successColor;

	const chip = (
		<Box
			data-testid={`extraction-confidence-${value}`}
			sx={{
				display: "inline-flex",
				alignItems: "center",
				padding: "2px 8px",
				borderRadius: "12px",
				backgroundColor,
				color: white,
				fontSize: 12,
				fontWeight: 700,
				lineHeight: 1.4,
			}}
		>
			{value}
		</Box>
	);

	if (!description) return chip;

	return (
		<Tooltip title={<Typography fontSize={12}>{description}</Typography>}>
			{chip}
		</Tooltip>
	);
};

export default ExtractionConfidenceBadge;
